import { axios } from "../utils/axios";
import { isAxiosError } from "axios";
import { toast } from "react-toastify";
import { useGeneralAppStore } from "../store/generalAppStore";
import { toastOptions } from "../config/toast";
import { handleGuardarCorreo } from "../screens/BuscarInfracciones/Formularios/handlers";

const useCaptcha = () => {
  const { handlerLoading, handlerModal } = useGeneralAppStore();

  //TREA TODO LOS NOTIFICADORES
  const getPregunta = async (
    setPregunta,
    orderRandom,
    setPreguntas,
    setImgSelect,
    setAnimacionPregunta,
  ) => {
    handlerLoading({ loading: true, loadName: "pregunta" });
    const response = await axios().get("/get_pregunta");
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        setAnimacionPregunta(true);
        orderRandom();
        setPregunta(data.pregunta);
        setPreguntas(data.preguntas);
        if (setImgSelect) {
          setImgSelect(null);
        }
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
      setTimeout(()=>{
        setAnimacionPregunta(false)
      },2000)
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "pregunta" });
  };

  const verificarCaptcha = async (
    dataSend,
    setPreguntas,
    setPregunta,
    datosSobre,
    valor,
    setDatosSobre,
    setValor,
    correoElectronico,
    setCorreoElectronico,
    setAnimacionPregunta,
    setVerify,
    setErrores,
    errores
  ) => {
    handlerLoading({ loading: true, loadName: "verificar" });
    const response = await axios().post("/verificar_captcha", dataSend);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        setVerify(true);
        handlerModal({modal:false, modalName:"captcha"})
      
        // handleGuardarCorreo(
        //   {
        //     valor: valor,
        //     datos_sobre: datosSobre,
        //     correo_electronico: correoElectronico,
        //   },
        //   setValor,
        //   setDatosSobre,
        //   setCorreoElectronico,
        //   handlerLoading,
        //   handlerModal
        // );
      }
      if (!data && error) {
        setErrores((prevState)=>prevState + 1 )
        setAnimacionPregunta(true)
        setPregunta(error.pregunta);
        setPreguntas(error.preguntas);
        if(errores < 3){
          toast.error("Respuesta incorrecta", toastOptions);
        }
        handlerLoading({ loading: false, loadName: "verificar" });
      }
      setTimeout(()=>{
        setAnimacionPregunta(false)
      },2000)
    } else {
      handlerLoading({ loading: false, loadName: "verificar" });
      toast.error("Hubo un error en la consulta", toastOptions);
      }
    handlerLoading({ loading: false, loadName: "verificar" });
  };

  return { getPregunta, verificarCaptcha };
};

export default useCaptcha;
